module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_5.0a77c091.png";